import { withStyles } from '@material-ui/core';

import SettingsCommonTable from '@/components/CommonTable';

import styles from './styles';

export default withStyles(styles)(SettingsCommonTable);
